/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  imports: [CommonModule],
  selector: 'env-banner',
  template: `<div class="warningBanner envBanner" *ngIf="env">Careful now &mdash; you're looking at: <span>{{env}}</span></div>`
})
export class EnvBannerComponent {
  @Input() env: string;
}
